import { render, staticRenderFns } from "./QuickmailMyPage.vue?vue&type=template&id=3ad6fa07&scoped=true&"
import script from "./QuickmailMyPage.vue?vue&type=script&lang=js&"
export * from "./QuickmailMyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew2_mypage.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad6fa07",
  null
  
)

export default component.exports